import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'std-modal',
  template: ` @if(show){
    <div
    (click)=" closeModal()"
      class="fixed top-0 left-0 z-[9999] h-[5000px]  !w-screen bg-black !bg-opacity-30 flex place-content-center items-center"
    >
       
    </div>
     <div
          [class]="
            'shadow-xl fixed z-[10000] flex mx-auto left-0 right-0 top-[10vh] w-fit flex-col rounded-xl max-h-[80vh] max-w-[80vw] ' +
            cardClass
          "
        >
          <div
            [class]="
              'p-3 w-full flex items-center justify-start bg-primary h-[55px] rounded-t-xl shadow-xl text-large ' +
              headerClass
            "
          >
            <ng-content select="[header]"></ng-content>
            <div
              *ngIf="showClose"
              (click)="closeModal(true)"
              [class]="'mr-[5px] ml-auto cursor-pointer ' + closeClass"
            >
              <svg
                class="w-5 h-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
              >
                <path
                  fill="#ffffff"
                  d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                />
              </svg>
              <ng-content select="[close]"></ng-content>
            </div>
          </div>
          <div
            [class]="
              'size-full p-5 bg-white rounded-b-xl max-h-[70vh] overflow-y-scroll custom-scroll-modal-kit ' +
              contentClass
            "
          >
            <ng-content select="[content]"></ng-content>
          </div>
        </div>
    }`,
  styles: `
  
.custom-scroll-modal-kit::-webkit-scrollbar {
  width: 0.6vh;
  height: 0.6vh;
}
.custom-scroll-modal-kit::-webkit-scrollbar-thumb {
  background: var(--primary);
  border-radius: 9999px;
  cursor: grab;
}
.custom-scroll-modal-kit::-webkit-scrollbar-thumb:active {
  cursor: grabbing !important;
}
.custom-scroll-modal-kit::-webkit-scrollbar-track {
  background: transparent;
}`,
  standalone: false,
})
export class ModalComponent {
  constructor() { }
  @Input() show: boolean = false;
  @Input() showClose: boolean = true;
  @Input() closeOnOutside: boolean = true;
  @Input() headerClass: string = '';
  @Input() cardClass: string = '';
  @Input() contentClass: string = '';
  @Input() closeClass: string = '';
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  closeModal(force?:boolean) {
    if (this.closeOnOutside || force) {
      setTimeout(() => {
        this.show = false;
        this.close.emit(this.show);
      }, 0);

    }
  }
}
